import React from "react";
import Modal from "../modal/Modal";
import { Button } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { FaTrash } from "react-icons/fa";

type TModalProps = {
  setModalVisible: (value: boolean) => void;
  modalVisible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const ConfirmationModal: React.FC<TModalProps> = ({
  setModalVisible,
  modalVisible,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      style="confirm-modal-container"
      stylecontent="confirm-modal-content"
      compact
      center
      visible={modalVisible}
      onClose={() => setModalVisible(false)}
    >
      <div className="text-center mb-20">
        <h2 className="f-w-700">{t("deleteSinglePrintData")}</h2>
      </div>
      <div className="text-center">
        <h1>
          <FaTrash />
        </h1>
      </div>

      <div className="row gap-30 row-column-phone-responsive">
        <Button mt={10} size="lg" color={"red"} fullWidth onClick={onConfirm}>
          {t("delete")}
        </Button>
        <Button
          className={"modal-outlined-button"}
          color={"blue"}
          variant={"outline"}
          mt={10}
          size="lg"
          fullWidth
          onClick={onCancel}
        >
          {t("cancel")}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
